import emptySplitApi from "../utils/rtk";
import { END_POINTS } from "../helpers";

export const notificationApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    allNotifications: builder.mutation({
      query: (body) => ({
        url: `${END_POINTS.allNotifications}`,
        method: "POST",
        body,
      }),
    }),

    deleteNotification: builder.mutation({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteNotification}${id}/`,
        method: "DELETE",
      }),
    }),

    addNotifications: builder.mutation({
      query: (body) => ({
        url: `${END_POINTS.addNotification}`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useAllNotificationsMutation,
  useDeleteNotificationMutation,
  useAddNotificationsMutation,
} = notificationApi;
